import React, { useEffect, useState } from "react";
import api from "../api";

const ProjectManagementDashboard = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const cardStyle = {
    background: "#fff",
    borderRadius: 12,
    padding: 20,
    boxShadow: "0 2px 8px rgba(0,0,0,.08)",
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      const res = await api.get("/projects");
      setProjects(res.data);
    } catch (err) {
      console.error(err);
      setError("Failed to load projects. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Derive summary stats from the loaded projects instead of a
  // hardcoded/undefined array
  const stats = [
    {
      title: "Total Projects",
      value: projects.length,
      color: "#4f46e5",
    },
    {
      title: "Completed",
      value: projects.filter((p) => p.status === "Completed").length,
      color: "#16a34a",
    },
    {
      title: "In Progress",
      value: projects.filter((p) => p.status === "In Progress").length,
      color: "#f59e0b",
    },
    {
      title: "Avg. Progress",
      value: projects.length
        ? `${Math.round(
            projects.reduce((sum, p) => sum + (p.progress || 0), 0) /
              projects.length,
          )}%`
        : "0%",
      color: "#0ea5e9",
    },
  ];

  return (
    <div style={{ padding: 24, background: "#f5f7fb", minHeight: "100vh" }}>
      <h1 style={{ marginBottom: 24 }}>Project Management Dashboard</h1>

      {loading && <p>Loading projects...</p>}
      {error && <p style={{ color: "#dc2626" }}>{error}</p>}

      {!loading && !error && (
        <>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))",
              gap: 20,
              marginBottom: 30,
            }}
          >
            {stats.map((item) => (
              <div
                key={item.title}
                style={{ ...cardStyle, borderLeft: `6px solid ${item.color}` }}
              >
                <h4 style={{ margin: 0, color: "#666" }}>{item.title}</h4>
                <h2 style={{ marginTop: 12 }}>{item.value}</h2>
              </div>
            ))}
          </div>

          <div style={cardStyle}>
            <h2>Projects</h2>

            {projects.length === 0 ? (
              <p>No projects found.</p>
            ) : (
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th align="left">Project</th>
                    <th align="left">Status</th>
                    <th align="left">Progress</th>
                  </tr>
                </thead>

                <tbody>
                  {projects.map((p) => (
                    <tr key={p.id ?? p.name}>
                      <td style={{ padding: "12px 0" }}>{p.name}</td>
                      <td>{p.status}</td>
                      <td style={{ width: 300 }}>
                        <div
                          style={{
                            width: "100%",
                            background: "#ddd",
                            height: 10,
                            borderRadius: 10,
                          }}
                        >
                          <div
                            style={{
                              width: `${p.progress}%`,
                              height: 10,
                              background: "#4f46e5",
                              borderRadius: 10,
                            }}
                          />
                        </div>
                        <small>{p.progress}%</small>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default ProjectManagementDashboard;
